export default "__VITE_ASSET__BYUiYJ56__"